import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/**
 * views/jomla/safe/form PUTs `{name}`. `cash` is the safe's running balance,
 * moved by the transfer/expense screens, and is not part of the form.
 *
 * hydrate is off because the jSafe endpoint has no getById.
 */
export default defineInlineEdit({
  api: "jSafe",
  permission: "safe_edit",
  hydrate: false,
  toPayload: (source) => ({ name: source.name ?? "" }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
  },
});
